export const inspectionSettings = {
  logic: "perTime",
};

// perTime
// perDays



// WEBPACK FOOTER //
// ./src/components/WorkPlanTemplate/JourneyPlanAddEdit/setting.js